<template>
  <div>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            v-bind="attrs"
            v-on="on"
            size="18"
            color="orange"
            v-show="type == 'Dry'"
          >
            mdi-white-balance-sunny
          </v-icon>
        </template>
        <span class="text-capitalize">Dry</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            color="red"
            v-bind="attrs"
            v-on="on"
            size="18"
            v-show="type == 'Chilled'"
          >
            mdi-ice-pop
          </v-icon>
        </template>
        <span class="text-capitalize">Chilled</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            color="blue"
            v-bind="attrs"
            v-on="on"
            size="18"
            v-show="type == 'Frozen'"
          >
            mdi-snowflake
          </v-icon>
        </template>
        <span class="text-capitalize">Frozen</span>
      </v-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      required: true,
    },
  },
};
</script>